import { render, staticRenderFns } from "./CustomerVisit.vue?vue&type=template&id=53c5cd22&scoped=true"
import script from "./CustomerVisit.vue?vue&type=script&lang=js"
export * from "./CustomerVisit.vue?vue&type=script&lang=js"
import style0 from "./CustomerVisit.vue?vue&type=style&index=0&id=53c5cd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5cd22",
  null
  
)

export default component.exports